"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateBundle = exports.getEnvironment = exports.requireAMDModule = exports.getGlobal = void 0;
/* eslint-disable no-new-func */
/* eslint-disable no-eval */
var RegistryError_1 = require("../errors/RegistryError");
var flags_1 = require("../flags");
var workaround = {};
/**
 * trick to leave `require` as is after webpack build
 * it makes possible to run the same bundle on server and client
 */
eval("workaround.getRequireFunction = () => typeof require !== 'undefined' ? require : undefined");
function getGlobal() {
    var currentGlobal = (typeof globalThis !== 'undefined'
        ? globalThis
        : typeof global !== 'undefined'
            ? global
            : typeof window !== 'undefined'
                ? window
                : null);
    /**
     * Temporary condition
     */
    if (currentGlobal === null) {
        console.log('');
        console.error("Registry Unreachable Case \u2013 \"get global variable\". \nPlease notify registry developers about this error.");
        console.log('');
    }
    return currentGlobal;
}
exports.getGlobal = getGlobal;
function requireAMDModule(id) {
    /**
     * This is workaround for webpack...
     * if just use `require` function directly, webpack will transpile it to
     * `__webpack_require__(n)` that always leads to module that throws exception like `module if not defined`
     */
    var localRequire = typeof __non_webpack_require__ === 'undefined'
        ? workaround.getRequireFunction()
        : __non_webpack_require__;
    if (!localRequire.specified) {
        throw RegistryError_1.createInternalException('"specified()" is not available from the "require" function');
    }
    return new Promise(function (resolve) {
        /**
         * Trigger `require` to fix `require.specified`
         * https://github.com/requirejs/requirejs/issues/1305#issuecomment-87924865
         **/
        localRequire([]);
        /**
         * To prevent fetching module with `requirejs`
         */
        if (localRequire.specified(id)) {
            localRequire([id], function (model) {
                resolve(model);
            });
        }
        else {
            resolve(undefined);
        }
    });
}
exports.requireAMDModule = requireAMDModule;
function getDefineFunction(id) {
    var currentGlobal = getGlobal();
    var _define = typeof currentGlobal.define === 'function' && currentGlobal.define.amd
        ? currentGlobal.define
        : null;
    /**
     * If components library was bundled with "umdNamedDefine: true", the UMD header in bundle will be:
     * ...
     * define('bundleId', [], factory)
     * ...
     *
     * If components "umdNamedDefine: false":
     * ...
     * define([], factory)
     * ...
     *
     * So this is anonymous define call, that means that it is not possible to require it after the evaluation
     * Better to track these cases.
     */
    var defineForBundle;
    if (_define) {
        defineForBundle = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (args.length === 3) {
                /**
                 * ID passed to the `define` function should equals to the ID from the manifest
                 */
                if (id && args[0] !== id) {
                    throw RegistryError_1.createException("Incorrect \"define()\" call. Bundle IDs miss match", RegistryError_1.RegistryErrorCode.BundleEvaluationError)
                        .withMissMatch(id, args[0])
                        .withHint('Probably library was bundled in a wrong way');
                }
                _define.apply(void 0, args);
            }
            else if (args.length === 2) {
                // if (!process.env.PRODUCTION) {
                console.warn("Probably library with \"" + id + "\" bundle was bundled without \"umdNamedDefine: true\" at the yoshi.config");
                // }
                _define.apply(void 0, __spreadArrays([id], args));
            }
            else {
                throw RegistryError_1.createException("Incorrect \"define()\" call. No arguments", RegistryError_1.RegistryErrorCode.BundleEvaluationError).withHint('Probably library was bundled in a wrong way');
            }
        };
        defineForBundle.amd = _define.amd;
    }
    return defineForBundle;
}
function getEnvironment(id) {
    return {
        /**
         * for requirejs environment
         */
        define: getDefineFunction(id),
        /**
         * `workaround.require` – always default require function
         * for SSR – it is node require
         * for CSR – it is requirejs
         */
        require: workaround.getRequireFunction(),
        /**
         * always force `module` to be undefine during bundle evaluation
         */
        module: undefined,
        /**
         * commonjs & commonjs2
         *
         * for server env. we provide `exports` as plain object
         * after evaluation, it is possible to get the results:
         * env.exports[bundleId]
         */
        exports: flags_1.isServer ? {} : undefined,
    };
}
exports.getEnvironment = getEnvironment;
function evaluateBundle(bundle, id) {
    var evaluateBundleSources = new Function('define', 'require', 'module', 'exports', bundle);
    var env = getEnvironment(id);
    /**
     *  TODO: possible exception on the server side, when loading bundle and runtime separately
     */
    evaluateBundleSources(env.define, env.require, env.module, env.exports);
    /**
     * Nothing to return bundle id was not passed
     */
    if (!id) {
        return undefined;
    }
    var currentGlobal = getGlobal();
    if (typeof env.define === 'function') {
        return requireAMDModule(id);
    }
    else if (typeof env.exports === 'object') {
        return env.exports[id];
    }
    else {
        var root = typeof self !== 'undefined' ? self : currentGlobal;
        // @ts-ignore
        return root[id];
    }
}
exports.evaluateBundle = evaluateBundle;
//# sourceMappingURL=evaluateBundle.js.map